<script>
import { ArrowUpIcon, MessageCircleIcon } from "vue-feather-icons";
import Navbar from "@/view/front/components/navbar";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import moment from "moment";
import JobSeekerService from "@/MainServices/JobSeekerService.js";
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor";

/**
 * Page-job-apply component
 */
export default {
  data() {
    return {
      MEDIA_URL: MEDIA_URL,
      loading: true,
      dialog: false,
      deleteId: null,
      deleting: false,
      success: false,
      submitting: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      createForm: false,
      updateForm: false,
      cvTitle: "",
      cvFile: "",
      cvId: null,
      nameRules: [
        (v) => !!v || "CV title is required",
        (v) =>
          (v && v.length <= 20) || "CV title must be less than 20 characters",
      ],
      headers: [
        { text: "CV Title", value: "cv_title" },
        { text: "Added On", value: "created_at" },
        { text: "SELECT DEFAULT", value: "default" },
        { text: "Action", value: "action" },
      ],
      data: [],
      introVideo: null,
      introVideosOptions: [],
      introAudio: null,
      introAudiosOptions: [],
      internelNotes: "",
      coverLetter: "",
      user_role: JSON.parse(localStorage.getItem("user")).role,
    };
  },
  components: {
    Navbar,
    Switcher,
    Footer,
    ArrowUpIcon,
    MessageCircleIcon,
    VueEditor,
  },
  mounted() {var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    if (localStorage.getItem("user") == null) {
      this.$router.push("/login");
      return;
    }
    this.getInititalData();
  },
  methods: {
    moment: function () {
      return moment();
    },
    getInititalData() {
      JobSeekerService.getMyCvs()
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });

      JobSeekerService.getMyVideos()
        .then((_res) => {
          this.introVideosOptions = [];
          this.loading = false;
          _res.data.forEach((element) => {
            this.introVideosOptions.push({
              value: element.id,
              text: element.title,
            });
          });
          this.introVideosOptions.unshift(
            ...[{ value: null, text: "Choose intro video" }]
          );
        })
        .catch(() => {
          this.loading = false;
        });
      // this.introAudiosOptions.unshift(
      //     ...[{ value: null, text: "Choose intro Audio" }]
      //   );
      JobSeekerService.getMyAudios()

        .then((_res) => {
          this.introAudiosOptions = [];
          this.loading = false;
          _res.data.forEach((element) => {
            this.introAudiosOptions.push({
              value: element.id,
              text: element.title,
            });
          });
          this.introAudiosOptions.unshift(
            ...[{ value: null, text: "Choose intro Audio" }]
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },

    cancel() {
      this.dialog = false;
      this.createForm = false;
      this.updateForm = false;
      this.cvTitle = "";
      this.cvFile = "";
      this.loading = false;
      this.success = true;
      this.submitting = false;
      this.introVideo = null;
      this.introAudio = null;
      this.internelNotes = "";
      this.coverLetter = "";
    },
    createFormEnable() {
      this.career_level = "";
      this.createForm = true;
      this.updateForm = false;
    },
    createCV() {
      if (this.cvTitle == "") {
        Swal.fire({
          title: "",
          text: "Please, provide CV title!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.cvFile == "") {
        Swal.fire({
          title: "",
          text: "Please, Choose your CV",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if ( this.cvFile.type == 'application/pdf' || this.cvFile.type == 'application/msword' || this.cvFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ) {
      }
      else{
        Swal.fire({
          title: "",
          text: "CV must be of type doc or pdf",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      this.submitting = true;
      let formData = new FormData();
      formData.append("cv_title", this.cvTitle);
      formData.append("cv_file", this.cvFile);
      formData.append("intro_video", this.introVideo);
      formData.append("intro_audio", this.introAudio);
      formData.append("cover_letter", this.coverLetter);
      formData.append("internel_notes", this.internelNotes);
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/job-seeker-get-cvs`, formData)
        .then((res) => {
          this.cancel();
          this.getInititalData();
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          }).then(function() {
            var upload_cv_path = sessionStorage.getItem("upload_cv_path");
            if (upload_cv_path) {
                // console.log("jobSesstion",upload_cv_path);
                window.location.href = upload_cv_path;
            }
          });
        })
        .catch(() => {
          this.loading = false;
          this.submitting = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section>
      <!-- <h4 class="title">Submit Job Application</h4> -->
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!-- Shape Start -->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg
          viewBox="0 0 2880 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!--Shape End-->

    <!-- Job apply form Start -->
    <section class="section pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-md-7">
            <div class="card custom-form border-0">
              <div class="card-body p-0">
                <div class="pl-4 pr-4 pt-4 pb-4 mb-0 job_listing_header">
                  <h3
                    class="title mb-0 simple-heading"
                    style="
                      color: #00bdf6;
                      padding: 0 !important;
                      font-size: 20px;
                    "
                  >
                    <span class="simple-heading" style="font-size: 20px"
                      >
                      Upload Your CV
                      </span
                    >
                  </h3>
                  <!-- <span class=""> </span> -->
                </div>
                  <v-card class="rounded shadow p-4 apply_page_ch">
                    <div style="padding: 2%">
                        <v-form ref="form" v-model="valid" lazy-validation>
                        <div class="row fields_uplood_cv">
                            <div class="col-md-4">
                            <v-text-field
                                v-model="cvTitle"
                                :rules="nameRules"
                                label="CV title"
                                required
                            ></v-text-field>
                            </div>

                            <div class="col-md-4">
                            <v-file-input
                                style="font-size: 8px"
                                label="Choose your CV"
                                v-model="cvFile"
                                accept=".pdf,.doc"
                            >
                            </v-file-input>
                            </div>
                        </div>
                        <div class="row" style="margin: 2% 0">
                            <div class="col-md-12 p-0">
                            <vue-editor
                                v-model="coverLetter"
                                outlined
                                name="input-7-4"
                                label="Cover letter"
                                rows="6"
                            ></vue-editor>
                            </div>
                        </div>
                        <v-btn
                            class="
                            btn uplaod_cv_btn btn-success
                            font-weight-bold
                            py-2
                            px-3 px-xxl-5
                            my-1
                            "
                            @click="createCV"
                            :disabled="
                            cvTitle === '' ||
                            (cvTitle === null && cvFile === '') ||
                            cvFile === null
                                ? true
                                : false
                            "
                            ><b-spinner small type="grow" v-if="submitting"></b-spinner>
                            Save
                        </v-btn>
                        <!-- <v-btn
                            style="margin-left: 6%"
                            class="
                            btn btn-sm btn-danger
                            font-weight-bold
                            py-2
                            px-3 px-xxl-5
                            my-1
                            "
                            @click="cancel"
                        >
                            Cancel
                        </v-btn> -->
                        </v-form>
                    </div>
                    </v-card>
                <!--end form-->
              </div>
            </div>
            <!--end custom-form-->
          </div>
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Job apply form End -->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
